import "./App.css";
import Home from "./pages/Home";
import "bootstrap/dist/css/bootstrap.css";

function App() {
  return (
    <div>
      <Home />
    </div>
  );
}

export default App;
